import React from 'react';

export const STEPS = [0.25, 0.5, 1, 2, 4, 8, 16, 32];

const FX = [
  ['filters', 'Filters', 'glow, drop shadow and bevel on type, cards and the pulse line'],
  ['bloom', 'Bloom', 'a full-frame bloom whose intensity follows the bass'],
  ['trails', 'Feedback trails', 'each frame blended over the last, zoomed'],
  ['blur', 'Layer blur', 'the colour blobs blurred as a layer'],
];

/** Stress controls: object count multiplier, effect switches, governor on/off. */
export default function StressPanel({ stress, setStress, fx, setFx, governor, setGovernor, onReset, disabled, base, steps, counts }) {
  const i = Math.max(0, steps.indexOf(stress));
  const shapes = counts ? counts.shapes : Math.round((base.shapes + base.morphs) * stress);
  const parts = counts ? counts.particleMax : Math.round(base.particles * stress * 3.23);
  return (
    <form className="stress" onSubmit={(e) => e.preventDefault()} aria-label="Stress test">
      <div className="stress-row">
        <label htmlFor="stress-range">Stress <b>×{stress}</b></label>
        <span className="stress-sub">{shapes.toLocaleString('en-US')} shapes · up to {parts.toLocaleString('en-US')} particles</span>
      </div>
      <input
        id="stress-range" type="range" min="0" max={steps.length - 1} step="1" value={i}
        onChange={(e) => setStress(steps[+e.target.value])} disabled={disabled}
        aria-valuetext={`times ${stress}, ${shapes} shapes`}
      />
      {stress >= 16 && <p className="stress-warn">Past what shedding can save: at this count the frame is bound by draw calls on the CPU, which no rung reduces. Scroll away and the hero pauses.</p>}
      <div className="stress-fx">
        {FX.map(([k, label, title]) => (
          <label key={k} className="chip" title={title}>
            <input type="checkbox" checked={!!fx[k]} onChange={(e) => setFx({ ...fx, [k]: e.target.checked })} disabled={disabled} />
            <span>{label}</span>
          </label>
        ))}
      </div>
      <div className="stress-row stress-gov">
        <span id="gov-label">Governor</span>
        <div className="seg" role="radiogroup" aria-labelledby="gov-label">
          <label className="seg-opt"><input type="radio" name="gov" checked={governor === 'auto'} onChange={() => setGovernor('auto')} disabled={disabled} /><span>Auto</span></label>
          <label className="seg-opt"><input type="radio" name="gov" checked={governor !== 'auto'} onChange={() => setGovernor('high')} disabled={disabled} /><span>Off</span></label>
        </div>
        <button type="button" className="linkish" onClick={onReset} disabled={disabled}>Reset</button>
      </div>
    </form>
  );
}
